import { render } from "./BlModelSearch.vue?vue&type=template&id=bce6a8ba&scoped=true"
import script from "./BlModelSearch.vue?vue&type=script&lang=js"
export * from "./BlModelSearch.vue?vue&type=script&lang=js"

import "./BlModelSearch.vue?vue&type=style&index=0&id=bce6a8ba&scoped=true&lang=scss"

import exportComponent from "/tmp/bc49b04f-2ffc-492f-a3c6-ed004d6cdf93/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bce6a8ba"]])

export default __exports__